<template lang="pug">
div
  section.u-mt-md
    AppTitle(:title="$t('mantra')")
    .grid.is-widescreen-8.is-desktop-10
      .column
        p.u-text-lg.u-mb-xs {{$t('mantraDesc')}}
        p.u-text-lg {{$t('mantraDesc2')}}

  section.u-mt-md
    .grid
      .column.is-widescreen-5
        AppTitle.u-mb-mi(:title="$t('sec1')" tag="h2")
      .column.is-widescreen-7
        .grid.is-tablet-6
          .column.u-mb-sm(v-for="item,idx in $t('sec1Items')")
            h4 {{item.title}}
            p {{item.desc}}

  section.u-mt-md
    .grid
      .column.is-widescreen-5
        AppTitle.u-mb-mi(:title="$t('sec2')" tag="h2")
      .column.is-widescreen-7
        .grid.is-tablet-6
          .column.u-mb-sm(v-for="item,idx in $t('sec2Items')")
            h4 {{item.title}}
            p {{item.desc}}

  section.u-mt-md.u-mb-md
    AppLink(to="/ordering" :title="$t('cta')" class="button-link is-large " v-html="$t('cta')")

</template>

<script>
export default {
  head() {
    const $t = this.$t.bind(this);
    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:image',
          name: 'og:image',
          property: 'og:image',
          content: 'https://cdn.baianat.com/static/share/services.png'
        },
        {
          hid: 'twitter:image',
          name: 'twitter:image',
          property: 'twitter:image',
          content: 'https://cdn.baianat.com/static/share/services.png'
        }
      ]
    };
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Internet of things",
    "pageDesc":"Providing internet of things solutions to support your business growth and create innovative values for your end users.",
    "mantra":"Connect your business |with IoT.",
    "mantraDesc":"Internet of Things is about connecting devices to each other and to the Internet. you could think of it as building a relationship between people-people, people-things, and things-things.",
    "mantraDesc2":"We develop in-house applications that cater to the IoT technology and customizable to various industries including Manufacturing, Hospitality, and Transportation.",
    "sec1":"Our IoT applications consists of three layers",
    "sec1Items":{
      "1":{
        "title":"The device Layer",
        "desc":"Create sensors, gateways, and communication protocols using WIFI, Bluetooth, Ethernet, etc."
      },
      "2":{
        "title":"The Business layer",
        "desc":"Enhance your business processes with Logic, event processing and systems integration."
      },
      "3":{
        "title":"The presentation layer",
        "desc":"Use IoT technology in mobile applications, web applications, and remote monitoring and control of interactive dashboards."
      }
    },
    "sec2":"Our IoT Process",
    "sec2Items":{
      "1":{
        "title":"Define, analyze and ideate",
        "desc":"Having an IoT Idea? Our IoT team will discuss it with you and help you transform it to a practical business case."
      },
      "2":{
        "title":"Prototype",
        "desc":"We develop an IoT roadmap to give you a clear picture how processes and things would be connected."
      },
      "3":{
        "title":"Development",
        "desc":"Here is where all the magic happens, Our IoT dedicated developer will start building your IoT application using cutting edge technologies."
      },
      "4":{
        "title":"Testing and feedback",
        "desc":"Our IoT team will test the application for quality and reliability issues and make sure that it’s working efficiently and shares the results with you to provide suggestions and product refinement."
      }
    },
    "cta":"Get your business <br> connected now"
  },
  "ar": {
    "pageTitle":"إنترنت الأشياء",
    "pageDesc":"نوفر لك حلول إنترنت الأشياء التي تدعم نمو أعمالك ونجاحها، وتساعدك على توفير أعمالك مبتكرة ومميزة للمستخدمين النهائيين.",
    "mantra":"اربط بين أعمالك والعالم |المحيط من خلال إنترنت الأشياء.",
    "mantraDesc":"ببساطة يعني انترنت الأشياء اتصال الأجهزة ببعضها البعض وبالإنترنت. يمكنك التفكير في الأمر على أنه علاقة ارتباط بين الأشياء والأشياء، الأشخاص والأشياء، الأشخاص والأشخاص. ",
    "mantraDesc2":"نقوم بتطوير تطبيقات داخلية تعمل على تلبية انترنت الأشياء وتخصيصها لمختلف الصناعات بما في ذلك التصنيع، والضيافة، والنقل.",
    "sec1":"تتكون تطبيقات إنترنت الأشياء من 3 طبقات",
    "sec1Items":{
      "1":{
        "title":"طبقة الجهاز",
        "desc":"إنشاء أجهزة استشعار وبوابات وبروتوكولات اتصال باستخدام واى فاى و بلوتوث و إيثرنت وما إلى ذلك."
      },
      "2":{
        "title":"طبقة الأعمال",
        "desc":"طَّور من عمليات عملك باستخدام المنطق ومعالجة الأحداث وتكامُل النظم. "
      },
      "3":{
        "title":"طبقة العرض",
        "desc":"استخدم تكنولوجيا انترنت الأشياء في تطبيقات المحمول وتطبيقات الويب في المراقبة والتحكم عن بعد في لوحات المعلومات التفاعلية."
      }
    },
    "sec2":"تتكون عملية انترنت الأشياء لدينا من:",
    "sec2Items":{
      "1":{
        "title":"عرّف وحلل ثم قدم الأفكار",
        "desc":"هل لديك فكرة عن إنترنت الأشياء؟ سيقوم فريقنا بمناقشته معك ومساعدتك على تحويله إلى حالة واقعية لعملك."
      },
      "2":{
        "title":"النموذج الأولي",
        "desc":"نقوم بتطوير خريطة الطريق لإنترنت الأشياء لنمنحك صورة واضحة عن كيفية توصيل العمليات والأشياء."
      },
      "3":{
        "title":"البرمجة",
        "desc":"سوف يبدأ المبرمجين لدينا المخصصين لعمليات إنترنت الأشياء في بناء تطبيقك باستخدام أحدث التقنيات."
      },
      "4":{
        "title":"الاختبار وردود الأفعال",
        "desc":"سيقوم فريقنا باختبار التطبيق لمعرفة مشكلات الجودة والموثوقية، والتأكد من أنه يعمل بكفاءة، ثم نعرض النتائج عليك لتوفير الاقتراحات وتحسين المنتج."
      }
    },
    "cta":"اجعل عملك أكثر <br> ارتباطًا بما حوله. "
  }
}
</i18n>
